export default __webpack_public_path__ + "static/media/service-garanti.deb04fba.png";